import React, { useContext, useEffect, useRef, useState } from 'react'
import lottie from 'lottie-web';
// import SpinHeader from '../assets/animation/SpinHeader.json';
import GoldenSpinHeader from '../assets/animation/GoldenSpinHeader.json';
import styled from 'styled-components';
import AppContext from 'Contexts/AppContext';
const SpinDiv = styled.div`
position:relative;
    & span{
    position: absolute;
    color: white;
    width: 10px;
    height: 10px;
    top: -3px;
    z-index: 10;
    font-size: 7px;
    background-color: red;
    border-radius: 50%;
    text-align: center;

    }
`;
function GoldenSpinerHeader() {
    const container = useRef(null);
    const [anim, setAnim] = useState<any>(null);
    const {megaSpinData} = useContext(AppContext);

    useEffect(() => {
        if (container.current) {
            const animation = lottie.loadAnimation({
                container: container.current,
                animationData: GoldenSpinHeader,
                loop: true,
                autoplay: false, // Set autoplay to false to control manually
            });
            setAnim(animation);
        }

        return () => {
            if (anim) {
                anim.destroy();
            }
        };
    }, []);

    useEffect(() => {
        if (anim) {
            const playAndStopAnimation = () => {
                anim.play();
                setTimeout(() => {
                    anim.stop();
                    setTimeout(playAndStopAnimation, 30000); // Schedule next play after 30 seconds
                }, 3000); // Animation duration
            };

            playAndStopAnimation(); // Start the cycle

            return () => {
                anim.stop();
            };
        }
    }, [anim]);

    return (
        <SpinDiv>
            {megaSpinData?.megaSpinAvailable > 0 &&<span
                className=''
                style={{
                    right: window.screen.width > 767 ? "1px" : "1px",
            }}
            >{megaSpinData?.megaSpinAvailable}</span>}
            <div ref={container}></div>
        </SpinDiv>       
    );
}

export default GoldenSpinerHeader;


